// Dawn constants - kept in module scope and explicitly attached to window
// so legacy classic <script> assets (cart.js, product-form.js, etc.) can
// resolve them as bare globals.

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

window.ON_CHANGE_DEBOUNCE_TIMER = ON_CHANGE_DEBOUNCE_TIMER;
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;

export { ON_CHANGE_DEBOUNCE_TIMER, PUB_SUB_EVENTS };
